import $____grader_overview_vm from './grader/overview-vm';
export default {
  openSubmission: function (item, event, confirmation_msg) {
    if (item.resubmittable_type() && !item.resubmittable()) {
      var open_submission = function () {
        var url = item.open_submission_path();

        var request = new Kadenze.AjaxRequest({
          type: 'POST',
          url: url,
          data: null,
          timeout: 60000
        });

        request.done(function(response, status, xhr) {
          item.resubmittable(true);
          new Kadenze.Notice.success({message: response.message});
        });

        request.fail(function(xhr, status, msg) {
          new Kadenze.Notice.error({message: 'There was an error opening submission. Please contact an administrator.'});
        });
      };
      if (confirmation_msg) {
        Kadenze.UIUtil.confirmAction(confirmation_msg, open_submission);
      } else {
        open_submission();
      }
    }
  },
  markAs: function (item, event, state) {
    var url = item[`mark_as_${state}_path`]();

    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: url,
      data: null,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      if (state == 'submitted') {
        item.coursework_placeholder_submitted(true);
        item.coursework_submitted(true);
        if (item.submission_time)
          item.submission_time(new Date().toISOString());
      } else {
        item.coursework_placeholder_submitted(false);
        item.coursework_submitted(false);
        if (item.submission_time)
          item.submission_time(null);
      }

      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: `There was an error marking this as ${state}. Please contact an administrator.`});
    });
  },
  downloadSubmission: function (item, event) {
    if (!item.form_builder_type() && !item.generic_type() && item.coursework_submitted()) {
      var url = item.create_archive_path();

      var request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: url,
        data: null,
        timeout: 60000
      });

      request.done(function(response, status, xhr) {
        new Kadenze.Notice.success({message: response.message});
      });

      request.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error({message: 'There was an error creating an archive for download. Please contact an administrator.'});
      });
    }
  },

  downloadAllSubmissions: item => {
    if (!item.form_builder_type()) {
      var url = item.create_archive_path();

      var request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: url,
        data: null,
        timeout: 60000
      });

      request.done(response => {
        new Kadenze.Notice.success({message: response.message});
      });

      request.fail(() => {
        new Kadenze.Notice.error({
          message: 'There was an error creating an archive for download. Please contact an administrator.'
        });
      });
    }
  },

  presentAutoGradingOption: function (has_overridden_grade_entries, skip_callback, overwrite_callback) {
    if (has_overridden_grade_entries) {
      Kadenze.UIUtil.confirmAction('This coursework has some grades that have been modified after auto-grading. How would you like the auto-grader to treat them?', function () {
        skip_callback();
      }, function () {
        overwrite_callback();
      }, {
        ok_btn_text: 'Skip modified grades',
        cancel_btn_text: 'Overwrite modified grades'
      });
    } else {
      skip_callback();
    }
  },
  rerunAutoGrading: function (course_id, coursework_entry_id, overwrite_grades) {
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_gradebook_coursework_entry_rerun_autograding_path(course_id, coursework_entry_id, {overwrite_grades: overwrite_grades}),
      data: null,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: 'There was an error running the auto-grader. Please contact an administrator.'});
    });
  },
  rerunAllAutoGrading: function (course_id, coursework_id, overwrite_grades) {
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_gradebook_coursework_rerun_autograding_path(course_id, coursework_id, {overwrite_grades: overwrite_grades}),
      data: null,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: 'There was an error running the auto-grader. Please contact an administrator.'});
    });
  },
  refreshAnalytics: function (course_id) {
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.refresh_course_gradebook_analytics_path(course_id),
      data: null,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: 'There was an error refreshing the analytics. Please contact an administrator.'});
    });
  },
  initSpeedGrader: function (item, event, filters, onClose) {
    Kadenze.UIUtil.showLoadingIndicator();
    var $el = $('#speed_grader_modal');
    var args = {
      $el: $el,
      course_id: $('#course_id').val(),
      coursework_id: item.coursework_data.id(),
      student_id: item.student_data.id(),
      filters: filters,
      speed_grader: true,
      onReady: function () {
        Kadenze.UIUtil.hideLoadingIndicator();
        $el.modal('show');
      }
    };
    var GraderOverviewVM = $____grader_overview_vm;
    var vm = new GraderOverviewVM(args);
    ko.cleanNode(args.$el[0]);
    ko.applyBindingsWithValidation(vm, $el[0], _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false}));
    $el.off('hide.bs.modal').on('hide.bs.modal', function() {
      //Persist any unsaved changes before closing
      vm.saveGrades(true).done(onClose);
    });
  },
  sendRequest: function (url, type, $el) {
    var request = new Kadenze.AjaxRequest({
      type: type,
      url: url,
      data: null,
      timeout: 60000,
      loadingIndicator: {
        container: $el
      }
    });

    request.done(function(response, status, xhr) {
      if (type != 'GET')
        new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, error) {
      new Kadenze.Notice.error({ message: xhr.responseJSON.message });
    });

    return request;
  },
  allowStudentPlagiarismVisibility: function(item, event) {
    var url = item.toggle_student_plagiarism_visibility_path();

    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: url,
      data: null,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      var currentValue = item.entry.student_can_see_plagiarism_report();
      item.entry.student_can_see_plagiarism_report(!currentValue);
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function(xhr, status, msg) {
      new Kadenze.Notice.error({message: 'There was an error allowing the student to view the plagiarism report. Please contact an administrator.'});
    });
  },
  reRunPlagiarismDetection: function(coursework, event) {
    const url = coursework.re_run_plagiarism_detection_path();

    const request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: url,
      data: null,
    });

    request.done(function(response){
      new Kadenze.Notice.success({message: response.message});
    });

    request.fail(function (xhr, status, msg) {
      new Kadenze.Notice.error({ message: 'There was an error re-running plagiarism detection. Please contact an administrator.' });
    });
  }
};

